<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <rect x="18.6001" y="7.76111" width="15.5825" height="3.08513" transform="rotate(135 18.6001 7.76111)" />
  <rect x="7.58154" y="5.40002" width="15.5825" height="3.08513" transform="rotate(45 7.58154 5.40002)" />
</svg>